import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class CrudService<T> {
  /**
   * Route controoler for api. slash only on end of value
   */
  protected controller = "some/";

  constructor(protected http: HttpClient) {}

  public get(onlyActive: string = "1"): Observable<T[]> {
    return this.http.get<T[]>(
      `${environment.serverUrl}api/${this.controller}get`,
      { params: { onlyActive } }
    );
  }

  public add(defa: T): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/${this.controller}add`,
      defa,
      options
    );
  }

  public update(defa: T): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/${this.controller}update`,
      defa,
      options
    );
  }

  public delete(i: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { i },
    };
    return this.http.get<any>(
      `${environment.serverUrl}api/${this.controller}remove`,
      options
    );
  }
  public activate(i: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { i },
    };
    return this.http.get<any>(
      `${environment.serverUrl}api/${this.controller}activate`,
      options
    );
  }
}
